import { useMemo } from "react"
import styled from "styled-components"
import { useMutation, useQuery } from '@apollo/client'
import { Link, useNavigate, useParams } from 'react-router-dom'
import {
    Descriptions as AntDesc,
    Popconfirm,
    Tag,
    Button,
    message
} from "antd"

import { LoadingView, Empty, Top, Image } from "../../components"
import { FIND_UNIQUE_STOCK, UPDATE_ONE_STOCK } from "../../gqls"

const Descriptions = styled(AntDesc)`
    max-width: 600px;
    font-size: 14px;
    .image {
        width: 100%;
        object-fit: cover;
        aspect-ratio: 16/9;
    }
`

const Controls = styled.div`
    margin-top: 15px;
`

const SingleStock = () => {
    const { id } = useParams()
    const navigate = useNavigate()

    const [updateStock, { loading: updateLoading }] = useMutation(UPDATE_ONE_STOCK, {
        onCompleted: ({ updateOneStock }) => {
            if (updateOneStock.delete){
                message.success("Акция удалена")
                navigate('/stock')
                return 
            }
            message.success("Акция обновлена")
            navigate('/stock')
        }
    })

    const { data, loading } = useQuery(FIND_UNIQUE_STOCK, {
        variables: {
            where: { id }
        }
    })

    const stock = useMemo(() => data ? data.findUniqueStock : null, [data])

    if (!stock && loading) {
        return <LoadingView loading />
    }
    if (!stock && !loading) {
        return <Empty description="Магазин не найден" />
    }
    if (stock && !loading) {
        return (
            <>
                <Top title={`Магазин "${stock.name}"`} />
                <Descriptions
                    title="Информация"
                    bordered
                    column={1}
                    layout='vertical'
                    labelStyle={{
                        fontWeight: 600
                    }}
                >
                    <Descriptions.Item label='Баннер'>
                        <Image
                            src={`/uploads/${stock.image}`}
                            className='image'
                            alt={stock.image}
                        />
                    </Descriptions.Item>
                    <Descriptions.Item label='Статус пубоикации'>
                        <Tag color={stock.publish ? "green" : "red"}>{stock.publish ? "Опубликована" : "Не опубликована"}</Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label='Название'>
                        {stock.title}
                    </Descriptions.Item>
                    <Descriptions.Item label='Описание'>
                        {stock.text}
                    </Descriptions.Item>
                    <Descriptions.Item label='Владелец'>
                        <Link to={`/admin/${stock.author.id}`}>
                            {stock.author.name}
                        </Link>
                    </Descriptions.Item>
                </Descriptions>
                <Controls>
                    {/* <Link to={`edit`}>
                        <Button type='primary' style={{ marginRight: 15 }}>
                            Редактировать
                        </Button>
                    </Link> */}
                    <Popconfirm
                        title='Удалить магазин?'
                        onConfirm={() => {
                            updateStock({
                                variables: {
                                    where: { id },
                                    data: {
                                        delete: { set: true }
                                    }
                                }
                            })
                        }}
                        disabled={updateLoading}
                    >
                        <Button
                            style={{ marginRight: 15 }}
                            type='danger'
                            loading={updateLoading}
                        >
                            Удалить
                        </Button>
                    </Popconfirm>
                    <Button
                        loading={updateLoading}
                        style={{ marginRight: 15 }}
                        onClick={() => {
                            updateStock({
                                variables: {
                                    where: { id },
                                    data: {
                                        publish: { set: !stock.publish }
                                    }
                                }
                            })
                        }}
                    >
                        {stock.publish ? "Снять с публикации" : "Опубликовать"}
                    </Button>
                </Controls>
            </>
        )
    }

    return null
}

export default SingleStock